// src/components/Dashboard/ClaimRecordModal.jsx
// Modal liviano para que un ajustador (o el admin) cree o edite un
// claimRecord desde el portal /claim-status, sin pasar por el wizard
// financiero completo de 4 pasos (QuickCreate.jsx, que sigue siendo
// exclusivo del panel admin) — solo el Paso 1 (CreateClaimRecord.jsx), que
// es puramente datos de caso, sin dinero.
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../App';
import Dialog from '../common/Dialog';
import CreateClaimRecord from './CreateClaimRecord';
import './CreateClaim.css';
import './ClaimRecordModal.css';

const ClaimRecordModal = ({ existingRecord, onClose, onSaved }) => {
  const { language } = useContext(LanguageContext);
  // Cualquier campo tocado marca el formulario como borrador: cerrar por clic
  // fuera, Escape o X pide confirmar antes de perder lo escrito.
  const [dirty, setDirty] = useState(false);

  const handleCreated = (record) => {
    onSaved?.(record);
    onClose();
  };

  return (
    <Dialog
      label={existingRecord ? (language === 'es' ? 'Editar reclamo' : 'Edit claim') : (language === 'es' ? 'Nuevo reclamo' : 'New claim')}
      language={language}
      dirty={dirty}
      onInput={() => setDirty(true)}
      onClose={onClose}
      overlayClassName="cc-modal-overlay"
      className="cc-modal-content cc-modal-content-wide"
    >
      {({ requestClose }) => (
        <>
          <button type="button" className="crm-modal-close" onClick={requestClose} aria-label={language === 'es' ? 'Cerrar' : 'Close'}>
            <i className="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
          <div className="crm-modal-scroll">
            <CreateClaimRecord existingRecord={existingRecord} onCreated={handleCreated} />
          </div>
        </>
      )}
    </Dialog>
  );
};

export default ClaimRecordModal;
